import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";


const initialState ={
    isLoading : false,
    productrates: [],
    totalProductRates: 0,
    numOfPages: 1,
    page: 1,
    stats: {},
    monthlyApplications: [],
    iscloading:false,
    cstatus:"",
    hstatus:"",
    hmessage:"",
    vmessage:"",
    cmessage:"",
    baseid:"",
    cdetails:{},
    ismloading:false,
    mstatus:"",
    mmessage:"",
    hpmessage:"",
    vpmessage:"",
    imessage:"",
    smessage:"",
    pmessage:"",
    apmessage:"",
    rmessage:"",
    rates: [],
    dstatus:"",
    dmessage:"",
    
};


const productratesListSlice = createSlice({
    name: "productratesList",
    initialState,
    reducers:{
        getProductRatesPending: (state) => {
            state.isLoading = true;
        },
        getProductRatesSuccess: (state, { payload }) => {
            state.isLoading = false;
            state.productrates = payload;
            state.cdetails = payload;
           // state.user="slice userData";
            state.error = '';
            console.log("lamha",payload)
        },
        getProductRatesFail: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
        },
        createProductRatesPending:(state,action) => {
            state.iscloading=true;
        },
        createProductRatesSuccess:(state,{payload}) => {
            state.iscloading=false;
            state.cstatus="success";
            state.cmessage=payload;
        },
        createProductRatesFail:(state,{payload}) => {
            state.iscloading=false;
            //state.cstatus="fail";
            //console.log('slice '+payload);
            state.cmessage=payload;
        },


        createAdultRatesPending:(state,action) => {
            state.iscloading=true;
        },
        createAdultRatesSuccess:(state,{payload}) => {
            console.log("sath",payload)
            state.iscloading=false;
            state.cstatus="success";
            state.baseid=payload;
        },
        createAdultRatesFail:(state,{payload}) => {
            state.iscloading=false;
            //state.cstatus="fail";
            //console.log('slice '+payload);
            state.cmessage=payload;
        },
        //hour


        createHourRatesPending:(state,action) => {
            state.iscloading=true;
        },
        createHourRatesSuccess:(state,{payload}) => {
            console.log("sath",payload)
            state.iscloading=false;
            state.hstatus="success";
            state.baseid=payload;
        },
        createHourRatesFail:(state,{payload}) => {
            state.iscloading=false;
            //state.cstatus="fail";
            //console.log('slice '+payload);
            state.hmessage=payload;
        },

        //vehicle

        createVehicleRatesPending:(state,action) => {
            state.iscloading=true;
        },
        createVehicleRatesSuccess:(state,{payload}) => {
            console.log("sath",payload)
            state.iscloading=false;
            state.hstatus="success";
            state.baseid=payload;
        },
        createVehicleRatesFail:(state,{payload}) => {
            state.iscloading=false;
            //state.cstatus="fail";
            //console.log('slice '+payload);
            state.vmessage=payload;
        },


        createChildRatesPending:(state,action) => {
            state.iscloading=true;
        },
        createChildRatesSuccess:(state,{payload}) => {
            state.iscloading=false;
            state.cstatus="success";
            state.cmessage=payload;
        },
        createChildRatesFail:(state,{payload}) => {
            state.iscloading=false;
            //state.cstatus="fail";
            //console.log('slice '+payload);
            state.cmessage=payload;
        },


        createInfantRatesPending:(state,action) => {
            state.iscloading=true;
        },
        createInfantRatesSuccess:(state,{payload}) => {
            state.iscloading=false;
            state.cstatus="success";
            state.cmessage=payload;
        },
        createInfantRatesFail:(state,{payload}) => {
            state.iscloading=false;
            //state.cstatus="fail";
            //console.log('slice '+payload);
            state.cmessage=payload;
        },


        createSeasonalRatesPending:(state,action) => {
            state.iscloading=true;
        },
        createSeasonalRatesSuccess:(state,{payload}) => {
            state.iscloading=false;
            state.cstatus="success";
            state.cmessage=payload;
        },
        createSeasonalRatesFail:(state,{payload}) => {
            state.iscloading=false;
            //state.cstatus="fail";
            //console.log('slice '+payload);
            state.cmessage=payload;
        },



        createPromotionRatesPending:(state,action) => {
            state.iscloading=true;
        },
        createPromotionRatesSuccess:(state,{payload}) => {
            state.iscloading=false;
            state.cstatus="success";
            state.cmessage=payload;
        },
        createPromotionRatesFail:(state,{payload}) => {
            state.iscloading=false;
            //state.cstatus="fail";
            //console.log('slice '+payload);
            state.cmessage=payload;
        },



        getSProductRatePending: (state) => {
            state.isLoading = true;
        },
        getSProductRateSuccess: (state, { payload }) => {
            state.isLoading = false;
            state.rates=payload;
           // state.user="slice userData";
            state.error = '';
        },
        getSProductRateFail: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
        },

        getSAProductRatePending: (state) => {
            state.isLoading = true;
        },
        getSAProductRateSuccess: (state, { payload }) => {
            state.isLoading = false;
            state.rates=payload;
           // state.user="slice userData";
            state.error = '';
        },
        getSAProductRateFail: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
        },
        modifyProductRatesPending:(state,action) => {
            state.ismloading=true;
            state.mstatus="";
        },
        modifyProductRatesSuccess:(state,{payload}) => {
            state.ismloading=false;
            state.mstatus="success";
           
            state.mmessage="ProductRates Successfully Updated";
        },
        modifyProductRatesFail:(state,{payload}) => {
            state.ismloading=false;
            state.mstatus="fail";
           // console.log('slice '+payload);
            state.mmessage=payload;
        },


        modifyAdultRatePending:(state,action) => {
            state.ismloading=true;
            state.mstatus="";
        },
        modifyAdultRateSuccess:(state,{payload}) => {
            state.ismloading=false;
            state.mstatus="success";
           
            state.mmessage="AdultRate Successfully Updated";
        },
        modifyAdultRateFail:(state,{payload}) => {
            state.ismloading=false;
            state.mstatus="fail";
            state.mmessage=payload;
        },


        modifyHourRatePending:(state,action) => {
            state.ismloading=true;
            state.mstatus="";
        },
        modifyHourRateSuccess:(state,{payload}) => {
            state.ismloading=false;
            state.mstatus="success";
           
            state.hpmessage="HourRate Successfully Updated";
        },
        modifyHourRateFail:(state,{payload}) => {
            state.ismloading=false;
            state.mstatus="fail";
            state.hpmessage=payload;
        },


        //vehicle
        modifyVehicleRatePending:(state,action) => {
            state.ismloading=true;
            state.mstatus="";
        },
        modifyVehicleRateSuccess:(state,{payload}) => {
            state.ismloading=false;
            state.mstatus="success";
           
            state.vpmessage="VehicleRate Successfully Updated";
        },
        modifyVehicleRateFail:(state,{payload}) => {
            state.ismloading=false;
            state.mstatus="fail";
            state.vpmessage=payload;
        },



        modifyChildRatePending:(state,action) => {
            state.ismloading=true;
            state.mstatus="";
        },
        modifyChildRateSuccess:(state,{payload}) => {
            state.ismloading=false;
            state.mstatus="success";
           
            state.mmessage="ChildRate Successfully Updated";
        },
        modifyChildRateFail:(state,{payload}) => {
            state.ismloading=false;
            state.mstatus="fail";
            state.mmessage=payload;
        },


        modifyInfantRatePending:(state,action) => {
            state.ismloading=true;
            state.mstatus="";
        },
        modifyInfantRateSuccess:(state,{payload}) => {
            state.ismloading=false;
            state.mstatus="success";
           
            state.imessage="Infant Successfully Updated";
        },
        modifyInfantRateFail:(state,{payload}) => {
            state.ismloading=false;
            state.mstatus="fail";
            state.imessage=payload;
        },




        modifySeasonalRatePending:(state,action) => {
            state.ismloading=true;
            state.mstatus="";
        },
        modifySeasonalRateSuccess:(state,{payload}) => {
            state.ismloading=false;
            state.mstatus="success";
           
            state.smessage="Infant Successfully Updated";
        },
        modifySeasonalRateFail:(state,{payload}) => {
            state.ismloading=false;
            state.mstatus="fail";
            state.smessage=payload;
        },




        modifyPromotionRatePending:(state,action) => {
            state.ismloading=true;
            state.mstatus="";
        },
        modifyPromotionRateSuccess:(state,{payload}) => {
            state.ismloading=false;
            state.mstatus="success";
           
            state.pmessage="Infant Successfully Updated";
        },
        modifyPromotionRateFail:(state,{payload}) => {
            state.ismloading=false;
            state.mstatus="fail";
            state.pmessage=payload;
        },



        deleteProductRatesPending:(state,action) => {
            state.isloading=true;
            state.dstatus="";
        },
        deleteProductRatesSuccess:(state,{payload}) => {
            state.isLoading=false;
            state.dstatus="success";
            state.dmessage="ProductRates Successfully Deleted";
        },
        deleteProductRatesFail:(state,{payload}) => {
            state.isLoading=false;
            state.dstatus="fail";
           // console.log('slice '+payload);
            state.dmessage=payload;
        },
//child rate delete

        deleteChildRatePending:(state,action) => {
            state.isloading=true;
            state.dstatus="";
        },
        deleteChildRateSuccess:(state,{payload}) => {
            state.isLoading=false;
            state.dstatus="success";
            state.dmessage="ChildRate Successfully Deleted";
        },
        deleteChildRateFail:(state,{payload}) => {
            state.isLoading=false;
            state.dstatus="fail";
           // console.log('slice '+payload);
            state.dmessage=payload;
        },



//infant rate delete

        deleteInfantRatePending: (state, action) => {
            state.isloading = true;
            state.dstatus = "";
        },
        deleteInfantRateSuccess: (state, { payload }) => {
            state.isLoading = false;
            state.dstatus = "success";
            state.dmessage = "InfantRate Successfully Deleted";
        },
        deleteInfantRateFail: (state, { payload }) => {
            state.isLoading = false;
            state.dstatus = "fail";
            state.dmessage = payload;
        },



        //seasonal rate delete

        deleteSeasonalRatePending: (state, action) => {
            state.isloading = true;
            state.dstatus = "";
        },
        deleteSeasonalRateSuccess: (state, { payload }) => {
            state.isLoading = false;
            state.dstatus = "success";
            state.smessage = "SeasonalRate Successfully Deleted";
        },
        deleteSeasonalRateFail: (state, { payload }) => {
            state.isLoading = false;
            state.dstatus = "fail";
            state.smessage = payload;
        },


        //promotion rate delete

        deletePromotionRatePending: (state, action) => {
            state.isloading = true;
            state.dstatus = "";
        },
        deletePromotionRateSuccess: (state, { payload }) => {
            state.isLoading = false;
            state.dstatus = "success";
            state.pmessage = "Promotion rate Successfully Deleted";
        },
        deletePromotionRateFail: (state, { payload }) => {
            state.isLoading = false;
            state.dstatus = "fail";
            state.pmessage = payload;
        },



        approveProductRatesPending:(state,action) => {
            state.isloading=true;
            state.dstatus="";
        },
        approveProductRatesSuccess:(state,{payload}) => {
            state.isLoading=false;
            state.dstatus="success";
            state.apmessage="ProductRates Approved Successfully";
        },
        approveProductRatesFail:(state,{payload}) => {
            state.isLoading=false;
            state.dstatus="fail";
           // console.log('slice '+payload);
            state.apmessage=payload;
        },


        rejectProductRatesPending:(state,action) => {
            state.isloading=true;
            state.dstatus="";
        },
        rejectProductRatesSuccess:(state,{payload}) => {
            state.isLoading=false;
            state.dstatus="success";
            state.rmessage="ProductRates Rejected Successfully";
        },
        rejectProductRatesFail:(state,{payload}) => {
            state.isLoading=false;
            state.dstatus="fail";
           // console.log('slice '+payload);
            state.rmessage=payload;
        },
        reset: () => initialState
    },
});

const { reducer, actions } = productratesListSlice;

export const { createAdultRatesFail,createAdultRatesPending,createAdultRatesSuccess,createChildRatesPending,
    createChildRatesFail,createChildRatesSuccess,createInfantRatesFail,createInfantRatesPending,
    createInfantRatesSuccess,createSeasonalRatesFail,createSeasonalRatesSuccess,createSeasonalRatesPending,createPromotionRatesFail,
    createPromotionRatesPending,createPromotionRatesSuccess,getSProductRateFail,
    getSProductRateSuccess,getSProductRatePending,deleteChildRateFail,deleteChildRatePending,
    deleteChildRateSuccess,deleteInfantRateFail,deleteInfantRatePending,deleteInfantRateSuccess,modifyAdultRateFail,modifyAdultRatePending,modifyAdultRateSuccess,
modifyChildRateFail,modifyChildRatePending,modifyChildRateSuccess,modifyInfantRateFail,modifyInfantRatePending,modifyInfantRateSuccess,modifySeasonalRateFail,
modifySeasonalRatePending,modifySeasonalRateSuccess,modifyPromotionRateFail,modifyPromotionRatePending,modifyPromotionRateSuccess,deleteSeasonalRateFail,deleteSeasonalRatePending,
deleteSeasonalRateSuccess,deletePromotionRateFail,deletePromotionRatePending,deletePromotionRateSuccess,
approveProductRatesFail,approveProductRatesPending,approveProductRatesSuccess,rejectProductRatesFail,rejectProductRatesPending,rejectProductRatesSuccess,
getSAProductRateFail,getSAProductRatePending,getSAProductRateSuccess, createHourRatesFail,createHourRatesPending,createHourRatesSuccess, modifyHourRateFail,modifyHourRatePending,modifyHourRateSuccess,
createVehicleRatesFail,createVehicleRatesPending,createVehicleRatesSuccess,modifyVehicleRateFail,modifyVehicleRateSuccess,modifyVehicleRatePending
} = actions;

export default reducer;
